import { createFileRoute } from '@tanstack/react-router';
import { JourneysComposerActionHandoff } from '@/pages/workspaces/composer/actions/[actionId]/routing';
import { validateComposerSearch } from './-composer-search';

/**
 * The `journeys` URL of the action composer, which every existing link uses.
 * Flag off it renders the embedded app; flag on it forwards an action this
 * app has a composer for to the composer's own URL, and renders the embedded
 * app for every other action.
 */
function JourneysComposerActionRoute() {
  const { actionId } = Route.useParams();

  return <JourneysComposerActionHandoff actionId={actionId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/composer/actions/$actionId')({
  component: JourneysComposerActionRoute,
  validateSearch: validateComposerSearch,
});
